module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/",
      "tag": "a",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('a', [_c('span', {
    staticClass: "glyphicon glyphicon-home",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.loggedIn) ? _c('router-link', {
    attrs: {
      "to": "/offers",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Offers")])]) : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.loggedIn) ? _c('router-link', {
    attrs: {
      "to": "/setup",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Setup")])]) : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(_vm.loggedIn) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.logOut()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Sign Out")])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "id": "ddown1",
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-987adcfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 271
// module chunks = 5